// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop--NZJVO6A-OW","visible":"visible--hFwYopciso","fixed":"fixed--aOYT+NGh1F"};